import React, { useContext, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Menu, MenuItem, Typography, Stack, Box, IconButton } from '@mui/material';
import '../Assets/styles/Header.css';
import Logoimg from '../Assets/Images/Goldsun-logo.jpg'
import profile from '../Assets/Images/profile.jpg';
import { logout } from '../Pages/login/auth';
import { useNavigate } from "react-router-dom";
import { MenuContext } from '../Pages/Dashboard/dashboard'
import NotificationIcon from '../Notification';
import { IoMdNotificationsOutline } from "react-icons/io";
import { decode as base64_decode, encode as base64_encode } from "base-64"
import CloseIcon from '@mui/icons-material/Close';
import { TbReload } from "react-icons/tb";
import ListAltIcon from '@mui/icons-material/ListAlt';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { config } from './CustomComponents/config';
import UnassignedParentProductsDialog from './UnassignedParentProductsDialog';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openUnassignedProducts, setOpenUnassignedProducts] = useState(false);
  const { selectedMenu, FormID, ...context } = useContext(MenuContext);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const ProfileDialog = ({ open, onClose }) => {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            bgcolor: 'white',
            borderBottom: '1px solid #eee',
            p: 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#eae7e7'
          }}
        >
          <Typography variant="h6"><b>Profile</b></Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography><b>Employee Code:</b> {base64_decode(localStorage.getItem('EmployeeCode'))}</Typography>
            <Typography><b>Name:</b> {localStorage.getItem('EmployeeName')}</Typography>
            <Typography><b>Department:</b> {localStorage.getItem('departmentName')}</Typography>
            <Typography><b>Role:</b> {base64_decode(localStorage.getItem('role'))}</Typography>
            <Typography><b>Unit:</b> {localStorage.getItem('unitName')}</Typography>
          </Stack>

          {/* Button section to view Unconfigured Parent Products */}
          <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e2e8f0' }}>
            <Typography variant="subtitle2" sx={{ color: '#4a5568', mb: 1, fontWeight: 600 }}>
              Unconfigured
            </Typography>
            <Button
              variant="outlined"
              fullWidth
              startIcon={<ListAltIcon />}
              onClick={() => {
                setOpenUnassignedProducts(true);
              }}
              sx={{
                justifyContent: 'space-between',
                textTransform: 'none',
                py: 1.2,
                px: 2,
                borderRadius: 1.5,
                borderColor: '#1976d2',
                color: '#1976d2',
                fontWeight: 600,
                bgcolor: '#f8fafc',
                '&:hover': {
                  bgcolor: '#edf2f7',
                  borderColor: '#1565c0',
                }
              }}
            >
              <span>Unconfigured</span>
              <span style={{
                backgroundColor: '#1976d2',
                color: 'white',
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '0.75rem',
                fontWeight: 'normal'
              }}>
                View List
              </span>
            </Button>
          </Box>
        </DialogContent>
        {/* <DialogActions>
        <Button onClick={onClose} variant="contained">Close</Button>
      </DialogActions> */}
      </Dialog>
    );
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const handleRecalculate = async () => {
    handleClose();
    const confirmResult = await Swal.fire({
      title: 'Recalculate Main Parent Stocks?',
      text: 'This will recalculate stock quantities for all main parent products in your unit. This may take a while.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, recalculate',
    });
    if (!confirmResult.isConfirmed) return;

    try {
      Swal.fire({
        title: 'Recalculating...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await fetch(config.Api + 'AddStock/recalculateMainParentStocks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ unitId: localStorage.getItem('unitId') }),
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || 'Failed to recalculate stocks');
      }

      Swal.close();
      context.alert({ type: 'success', message: result.message || 'Main parent stocks recalculated successfully!', show: true });
    } catch (error) {
      Swal.close();
      context.alert({ type: 'error', message: error.message || 'Something went wrong.', show: true });
    }
  };

  return (
    <header className="header">
      <ProfileDialog
        open={openProfile}
        onClose={() => setOpenProfile(false)}
      />
      <UnassignedParentProductsDialog
        open={openUnassignedProducts}
        onClose={() => setOpenUnassignedProducts(false)}
      />
      <div className="logo-container">
        <img src={Logoimg} alt="Logo" className="logo-image" />
        {/* <span className='logotxt'>Inventory</span> */}
        {/* <div className='locationDiv'> */}
        <span style={{ paddingTop: '20px', color: 'black' }}><b>{selectedMenu}</b></span>
        {/* </div> */}
      </div>
      {/* <div style={{color:'black'}}>
        <b>{localStorage.getItem('unitName')}</b>
      </div> */}
      <div style={{ display: 'flex' }}>
        <div style={{ color: 'black', display: 'flex', alignItems: 'center' }}>
          <TbReload style={{ width: '50px', height: '20px', color: 'blue' }} onClick={() => {
            window.location.reload()
          }} />
          <b> Welcome to {localStorage.getItem('unitName')}, {localStorage.getItem('EmployeeName')} !</b>
          <NotificationIcon unitId={localStorage.getItem('unitId')} style={{ width: '30px', height: '20px', color: 'red' }} />
        </div>
        <div className='ProfileDropdown' onClick={handleClick}>
          <img src={profile} alt="User" className="ProfileImgSty" /></div>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => setOpenProfile(true)}>Profile</MenuItem>
        <MenuItem onClick={() => {
          handleClose();
          setOpenUnassignedProducts(true);
        }}>Unconfigured</MenuItem>
        <MenuItem onClick={() => {
          window.location.reload()
        }}>Refresh</MenuItem>
        <MenuItem onClick={handleRecalculate}>Recalculate</MenuItem>
        <MenuItem onClick={() => {
          handleClose(); logout();
          navigate("/login");
          localStorage.clear();
        }}>Logout</MenuItem>
        <MenuItem >
          V-2.3.7
        </MenuItem>
      </Menu>


    </header>
  );
};

export default Header;
